import { Injectable, Inject } from '@angular/core';
import { RefundStatusRq } from '../../models/RefundStatusRq';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WINDOW } from 'src/app/models/WindowProvider';
import { BASE_URL } from 'src/app/models/Url';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class RefundStatusService {

//  refundStatusURL = '/selfServiceRefund/refund/status/';
  refundStatusURL = '/refund/status';
  errorURL = '/error';

  constructor(private http: HttpClient,
              @Inject(BASE_URL) public baseUrl: string,
              @Inject(WINDOW) private window: Window) {
              }

  checkRefundStatus(refundStatusRq: RefundStatusRq): Observable<string> {
    refundStatusRq.refundLookupStatus = refundStatusRq.refundLookupStatus
      .map(refundLookup => ({
        lastName: refundLookup.lastName.trim(),
        ticketNumber: refundLookup.ticketNumber.trim()
      }));

    return this.http.post<string>(this.baseUrl + this.refundStatusURL, refundStatusRq,
        {
          headers: httpOptions.headers,
          responseType: 'text' as 'json'
        });
      }

  error(): Observable<any> {
    return this.http.get(this.baseUrl + this.errorURL, { responseType: 'text' });
  }

  getHostname(): string {
    return this.window.location.hostname;
  }

}
